import React from 'react';

import { images } from '../../constants';

import './AboutUs.css';

const AboutUs = () => (
  <div className='app__aboutus app__bg flex__center section__padding' id='about'>
    <div className="app__aboutus-overlay flex__center">
      <img src={ images.G } alt="background letter" />
    </div> 

    <div className="app__aboutus-content flex__center">
      <div className="app__aboutus-content_about">
        <div className="headtext__cormorant">About Us</div>

        <img src= {images.spoon} alt="spoon" className='spoon-about__img' />

        <p className='p__opensans'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente voluptates temporibus autem ullam, aperiam quidem nulla similique placeat excepturi, facilis expedita doloremque fuga non, quo consequatur esse iure! Quo, dolorum!</p>

        <button type="button" className='custom__button'>Read more</button>
      </div>

      <div className="app__aboutus-content_knife flex__center">
        <img src={ images.knife} alt="knife" />
      </div>

      <div className="app__aboutus-content_history">
        <div className="headtext__cormorant">Our History</div>

        <img src= {images.spoon} alt="spoon" className='spoon-history__img' />

        <p className='p__opensans'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente voluptates temporibus autem ullam, aperiam quidem nulla similique placeat excepturi, facilis expedita doloremque fuga non, quo consequatur esse iure! Quo, dolorum!</p>

        <button type="button" className='custom__button'>Read more</button>
      </div>

    </div>
  </div>
);

export default AboutUs;
